import { defineMessages } from 'react-intl';

export default defineMessages({
  LinkTypeLabel: {
    id: 'ProfileLinks.Type.Label',
    defaultMessage: 'Profile Link Type',
  },
  LinkRequiredMessage: {
    id: 'ProfileLinks.Link.RequiredMessage',
    defaultMessage: 'Please complete this required field',
  },
  TypeRequiredMessage: {
    id: 'ProfileLinks.Type.RequiredMessage',
    defaultMessage: 'Please complete this required field',
  },
  AddButton: {
    id: 'ProfileLinks.AddButton.Label',
    defaultMessage: 'Add Profile Link',
  },
  AddMoreButton: {
    id: 'ProfileLinks.AddMoreButton.Label',
    defaultMessage: 'Add Additional Profile Link',
  },
  RemoveButton: {
    id: 'ProfileLinks.RemoveButton.Label',
    defaultMessage: 'Remove',
  },
  Caption: {
    id: 'ProfileLinks.Caption',
    defaultMessage: 'Profile Link {index}',
  },
});
